import type { CompassFilterStatus, GovernanceStatus } from '$/requests/GovernanceCheck.ts';

/** Figma COMPASS™ Review — pale surfaces + saturated text per status. */
export const COMPASS_REVIEW_THEME = {
  pass: {
    surface: 'bg-[#E8F5E9]',
    text: 'text-[#2D7D46]',
    border: 'border-[#C8E6C9]',
  },
  caution: {
    surface: 'bg-[#FFFDE7]',
    text: 'text-[#D4A017]',
    border: 'border-[#F0E6B8]',
  },
  escalation: {
    surface: 'bg-[#FFEBEE]',
    text: 'text-[#E57373]',
    border: 'border-[#FFCDD2]',
  },
} as const;

export function compassThemeForGovernanceStatus(status: GovernanceStatus) {
  return COMPASS_REVIEW_THEME[status];
}

export function compassThemeForFilterStatus(status: CompassFilterStatus) {
  if (status === 'passed') return COMPASS_REVIEW_THEME.pass;
  return COMPASS_REVIEW_THEME[status];
}
